<template lang="pug">
v-row.align-center.ma-0
  server-data(
    ref="serverData"
    v-slot:default="{ serverData, selectProps, loadMoreItems, search }"
    searchFieldName="search[name]"
    :query="query"
    :method="fetch"
    @init="resetQuery"
  )
    v-autocomplete-more(
      v-bind="{ ...selectProps, ...$attrs }"
      v-model="value"
      item-text="name"
      item-value="id"
      :label="label"
      rounded filled
      @update:search-input="search"
      @load-more-items="loadMoreItems"
      @input="$emit('input', $event)"
    )
</template>
<script>
export default {
  name: 'SelectCourse',
  props: {
    value: { type: [Number, Object, Array], default: null },
    label: { type: String, default: '' },
  },
  data() {
    return {
      query: { 'search[id]': this.value },
    };
  },
  methods: {
    resetQuery() {
      this.query = {};
    },
    fetch(data) {
      return this.$api.dir.specialitiesGroups(data);
    },
  },
};
</script>
